module.exports = __webpack_public_path__ + "img/image_26.f4915c5f.png";